import React, { useRef } from 'react';
import { useFragment, graphql } from 'react-relay';
import { Text } from '@atlaskit/primitives';
import type { radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView$key as RadioSelectFragment } from '@atlassian/jira-relay/src/__generated__/radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView.graphql';
import { EmptyFieldText } from '@atlassian/jira-issue-empty-field-text/src/ui/index.tsx';
import { HoverPopover } from '@atlassian/jira-hover-popover/src/ui/index.tsx';
import mergeRefs from '@atlassian/jira-merge-refs/src/index.tsx';
import type { RadioSelectReadViewProps } from './types.tsx';

/**
 * The RadioSelectReadView will show a read only view of RadioSelect field.
 * @param props [RadioSelectReadViewProps](./types.tsx)
 */
export const RadioSelectReadView = ({
	fragmentRef,
	maxLines,
	shouldRenderHoverPopover,
}: RadioSelectReadViewProps) => {
	const data = useFragment<RadioSelectFragment>(
		graphql`
			fragment radioSelect_issueFieldRadioSelectReadviewFull_RadioSelectReadView on JiraRadioSelectField {
				selectedOption {
					label: value
				}
			}
		`,
		fragmentRef,
	);
	const { selectedOption } = data;

	const contentRef = useRef(null);

	if (!selectedOption?.label) {
		return <EmptyFieldText />;
	}

	if (shouldRenderHoverPopover) {
		return (
			<HoverPopover content={selectedOption?.label} contentRef={contentRef}>
				{({ ref }) => (
					<Text maxLines={maxLines} ref={mergeRefs(ref, contentRef)}>
						{selectedOption?.label}
					</Text>
				)}
			</HoverPopover>
		);
	}

	return (
		<Text maxLines={maxLines} ref={contentRef}>
			{selectedOption?.label}
		</Text>
	);
};
